import { render, staticRenderFns } from "./top.vue?vue&type=template&id=18956b74&scoped=true&"
import script from "./top.js?vue&type=script&lang=js&"
export * from "./top.js?vue&type=script&lang=js&"
import style0 from "./top.css?vue&type=style&index=0&id=18956b74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18956b74",
  null
  
)

export default component.exports